export enum ReviewedStatusEnum {
  Unviewed = 'unviewed',
  Unsubmitted = 'unsubmitted',
  Submitted = 'submitted',
  Reviewed = 'reviewed',
}
